class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



// =============================
// FREE CHARGER CART VALIDATION (WORKING FOR DAWN)
// =============================

function initFreeChargerCheck() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  function showCartError(message) {
    let existing = drawer.querySelector('.cart-error-message');
    if (existing) existing.remove();

    const msg = document.createElement('div');
    msg.className = 'cart-error-message';
    msg.textContent = message;
    msg.style.color = 'red';
    msg.style.fontWeight = '600';
    msg.style.margin = '10px 0';
    msg.style.textAlign = 'center';

    const footer = drawer.querySelector('.cart-drawer__footer') || drawer;
    footer.prepend(msg);
  }

  async function checkRules(e) {
    const cart = await getCart();
    let freeCount = 0;
    cart.items.forEach((item) => {
      if (item.product.tags && item.product.tags.includes('free_product')) {
        freeCount += item.quantity;
      }
    });

    // Rule A: One free charger max
    if (freeCount > 1) {
      e.preventDefault();
      showCartError('You can only checkout with one free charger per order.');
      return false;
    }

    // Rule B: If tagged customer already received one
    if (window.customerHasFreeTag && freeCount > 0) {
      e.preventDefault();
      showCartError('You have already received a free charger. You cannot order another one.');
      return false;
    }

    return true;
  }

  // Attach listener whenever drawer updates
  const observer = new MutationObserver(() => {
    const checkoutBtn = drawer.querySelector('button[name="checkout"]');
    if (checkoutBtn && !checkoutBtn.dataset.freeCheckBound) {
      checkoutBtn.dataset.freeCheckBound = true;

      checkoutBtn.addEventListener('click', async (e) => {
        const valid = await checkRules(e);
        if (valid) {
          checkoutBtn.closest('form').submit();
        }
      });
    }
  });

  observer.observe(drawer, { childList: true, subtree: true });
}

document.addEventListener('shopify:section:load', initFreeChargerCheck);
document.addEventListener('DOMContentLoaded', initFreeChargerCheck);


// TRIGGER CART CHECK ON ITEM REMOVAL
if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItemsExtended extends CartDrawerItems {
    updateQuantity(line, quantity, name, sectionsToRender) {
      super.updateQuantity(line, quantity, name, sectionsToRender);
    
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }, 500);
    }

    getSectionsToRender() {
      const sections = super.getSectionsToRender();
      
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }, 500);
      
      return sections;
    }
  }

  customElements.define('cart-drawer-items-extended', CartDrawerItemsExtended);
  
  // Replace existing cart-drawer-items with extended version
  document.addEventListener('DOMContentLoaded', () => {
    const existingItems = document.querySelector('cart-drawer-items');
    if (existingItems) {
      const newItems = document.createElement('cart-drawer-items-extended');
      newItems.innerHTML = existingItems.innerHTML;
      existingItems.parentNode.replaceChild(newItems, existingItems);
    }
  });
}

// Also listen to cart changes via MutationObserver
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
    
    observer.observe(cartDrawer, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
});
